import { ShopPromotionsComponent } from './shop-promotions/shop-promotions.component';
import { AdditionalFeaturesPopupComponent } from './additional-features-popup/additional-features-popup.component';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AdditionalFeaturesRoutingModule } from './Additional-Features-routing.module';
import { ManageKMZComponent } from './manage-KMZ/manage-KMZ.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectFilterModule } from 'mat-select-filter';
import { LoginDetailsComponent } from './login-details/login-details.component';
import { AddLoginFormComponent } from './add-login/add-login.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { ManageServiceProviderComponent } from './manage-service-provider/manage-service-provider.component';
import { ManageServiceProviderEditComponent } from './manage-service-provider-edit/manage-service-provider-edit.component';
import { MatTabsModule } from '@angular/material/tabs';
import { SearchhistoryComponent } from './searchhistory/searchhistory.component';
import { ManageResellerComponent } from './manage-reseller/manage-reseller.component';
import { ManageResellerAddComponent } from './manage-reseller-add/manage-reseller-add.component';
import { UploadFSANNumberComponent } from './upload-FSAN-Number/upload-FSAN-Number.component';
import { ManageResellerProductComponent } from './manage-reseller-product/manage-reseller-product.component';
import { ManageProductComponent } from './manage-product/manage-product.component';
import { ManageProductAddComponent } from './manage-product-add/manage-product-add.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatCarouselModule } from 'ng-mat-carousel';
import { ManageSubCategComponent } from './manage-sub-Categ/manage-sub-Categ.component';
import { AddManageSubCategComponent } from './manage-sub-Categ-add/manage-sub-Categ-add.component';
import { ManageSalesRepComponent } from './manage-sales-rep/manage-sales-rep.component';
import { AddManageSalesRepComponent } from './manage-sales-rep-add/manage-sales-rep-add.component';
import { ShopPromotionsAddComponent } from './shop-promotions-add/shop-promotions-add.component';
import { SalesTargetSetupComponent } from './sales-target-setup/sales-target-setup.component';
import { AddSalesTargetSetupComponent } from './sales-target-setup-add/sales-target-setup-add.component';
import { VumatelProductMappingComponent } from './vumatel-product-mapping/vumatel-product-mapping.component';
import { PopupSalesTargetSetupComponent } from './sales-target-setup-popup/sales-target-setup-popup.component';
import { ShoppingConfigurationComponent } from './shopping-configuration/shopping-configuration.component';
import { CustomerPriceUpdateComponent } from './customer-price-update/customer-price-update.component';
import { SchoolPackageComponent } from './school-package/school-package.component';
import { CustomerAmmendmentComponent } from './customer-ammendment/customer-ammendment.component';
import { ManageDeviceComponent } from './manage-device/manage-device.component';
import { AddDevicePopupComponent } from './add-device-popup/add-device-popup.component';
import { CourierWaybilComponent } from './courier-waybil/courier-waybil.component';
import { ManageServiceChangeRequestComponent } from './manage-service-change-request/manage-service-change-request.component';
import { ManageServiceChangePopupComponent } from './manage-service-change-popup/manage-service-change-popup.component';
import { UpgradeApprovalComponent } from './upgrade-approval/upgrade-approval.component';
import { NgxEditorModule } from "ngx-editor";
import { ManageCancellationComponent } from './manage-cancellation/manage-cancellation.component';
import { ManageCancellationPopupComponent } from './manage-cancellation-popup/manage-cancellation-popup.component';
import { ProductDetailsPopupComponent } from './product-details-popup/product-details-popup.component';
import { ManageActivityComponent } from './manage-activity/manage-activity.component';
import { AddActivityComponent } from './add-activity/add-activity.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ManageActionComponent } from './manage-action/manage-action.component';
import { ManageActionDetailsComponent } from './manage-action-details/manage-action-details.component';
import { NewUserComponent } from './new-user/new-user.component';
import { RainItemizedBillingComponent } from './rain-itemized-billing/rain-itemized-billing.component';
import { CustomDatePopupComponent } from './custom-date-popup/custom-date-popup.component';
import { LinkAddressChangeComponent } from './link-address-change/link-address-change.component';
import { TraceRemovalOperationComponent } from './trace-removal-operation/trace-removal-operation.component';
import { ManageSuspensionComponent } from './manage-suspension/manage-suspension.component';
import { ManageSuspensionPopupComponent } from './manage-suspension-popup/manage-suspension-popup.component';
import { ManageAdhocComponent } from './manage-adhoc/manage-adhoc.component';
import { LoginTrendAnalysisComponent } from './login-trend-analysis/login-trend-analysis.component';
import { ManageAdhocPopupComponent } from './manage-adhoc-popup/manage-adhoc-popup.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ViewAllFnoPackagesComponent } from './view-all-fno-packages/view-all-fno-packages.component';
import { CarouselModule, } from 'ngx-owl-carousel-o';
import { TruncPipe } from './view-all-fno-packages/decimalpipe';
import { MessagingComponent } from './messaging/messaging.component';
import { MessagingAddComponent } from './messaging-add/messaging-add.component';
import { PortalNotificationsComponent } from './portal-notifications/portal-notifications.component';
import { CollectionComponent } from './collection/collection.component';
import { CollectionPopupComponent } from './collection-popup/collection-popup.component';
import { ProductAndPriceChangeComponent } from './product-and-price-change/product-and-price-change.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { PaymentArrangementComponent } from './payment-arrangement/payment-arrangement.component';
import { ChangeOfBankDetailsComponent } from './change-of-bank-details/change-of-bank-details.component';
import { AmendBankingDetailsComponent } from './amend-banking-details/amend-banking-details.component';
import { BulkSuspensionReactivationComponent } from './bulk-suspension-reactivation/bulk-suspension-reactivation.component';
import { AddBulkSuspensionComponent } from './add-bulk-suspension/add-bulk-suspension.component';
import { ManagePushNotificationComponent } from './manage-push-notification/manage-push-notification.component';
import { ManagePushNotificationAddComponent } from './manage-push-notification-add/manage-push-notification-add.component';
import { VumatelNetworkEventsComponent } from './vumatel-network-events/vumatel-network-events.component';
import { ViewVumatelNetworkEventsComponent } from './view-vumatel-network-events/view-vumatel-network-events.component';
import { SharedModule } from "../../shared/shared.module";
import { ColorPickerModule } from 'ngx-color-picker';
import { bannercomponent, PromotionSimulationComponent } from './promotion-simulation/promotion-simulation.component';
import { ManagePromotionAddComponent } from './manage-promotion-add/manage-promotion-add.component';
import { ManagePromotionComponent } from './manage-promotion/manage-promotion.component';
import { QuillModule } from 'ngx-quill';
import { DrawerComponent } from './drawer/drawer.component';
import { NetworkOutageComponent } from './network-outage/network-outage.component';
import { NetworkOutageAddComponent } from './network-outage-add/network-outage-add.component';
import { MatMenuModule } from '@angular/material/menu';
import { ButtonsComponent } from '../buttons/buttons.component';
import { RemovePromotionComponent } from './remove-promotion/remove-promotion.component';
import { LteManageInventoryComponent } from './lte-manage-inventory/lte-manage-inventory.component';
import { LtetopuphistoryComponent } from './ltetopuphistory/ltetopuphistory.component';
import { ManageOtpNotificationComponent } from './manage-otp-notification/manage-otp-notification.component';
import { ManageReferralFriendsComponent } from './manage-referral-friends/manage-referral-friends.component';
import { MatDividerModule } from "@angular/material/divider";
import { RelocationReferralPopupComponent } from './relocation-promotion/relocation-referral-popup/relocation-referral-popup.component';
import { RelocationPromotionComponent } from './relocation-promotion/relocation-promotion/relocation-promotion.component';
import { ManageRelocationPromotionComponent } from './relocation-promotion/manage-relocation-promotion/manage-relocation-promotion.component';
import { ManagePaymentArrangementComponent } from './manage-payment-arrangement/manage-payment-arrangement.component';
import { MonthYearPickerComponent, SuspensionScheduleComponent } from './suspension-schedule/suspension-schedule.component';
import { SuspensionProcessHistoryComponent } from './suspension-process-history/suspension-process-history.component';
import { MatCardModule } from '@angular/material/card';
import { AccountTransferExistingComponent } from './account-transfer-existing/account-transfer-existing.component';
import { NetworkStatusComponent } from './network-status/network-status.component';
import { HeaderModule } from "../header/header.module";
import { ManageResellerSalesComponent } from './manage-reseller-sales/manage-reseller-sales.component';
import { ManageResellerSalesAddComponent } from './manage-reseller-sales-add/manage-reseller-sales-add.component';
import { RadactComponent } from './radact/radact.component';

@NgModule({
  declarations: [
    ManageKMZComponent,
    LoginDetailsComponent,
    AddLoginFormComponent,
    ManageServiceProviderComponent,
    ManageServiceProviderEditComponent,
    SearchhistoryComponent,
    ManageResellerComponent,
    ManageResellerAddComponent,
    AdditionalFeaturesPopupComponent,
    UploadFSANNumberComponent,
    ManageResellerProductComponent,
    ManageProductComponent,
    ManageProductAddComponent,
    ShopPromotionsComponent,
    ShopPromotionsAddComponent,
    AddManageSubCategComponent,
    ManageSalesRepComponent,
    AddManageSalesRepComponent,
    SalesTargetSetupComponent,
    AddSalesTargetSetupComponent,
    ManageSubCategComponent,
    VumatelProductMappingComponent,
    PopupSalesTargetSetupComponent,
    ShoppingConfigurationComponent,
    CustomerAmmendmentComponent,
    CustomerPriceUpdateComponent,
    SchoolPackageComponent,
    ManageDeviceComponent,
    AddDevicePopupComponent,
    CourierWaybilComponent,
    ManageServiceChangeRequestComponent,
    ManageServiceChangePopupComponent,
    UpgradeApprovalComponent,
    ManageCancellationComponent,
    ManageCancellationPopupComponent,
    ProductDetailsPopupComponent,
    ManageActivityComponent,
    AddActivityComponent,
    ManageActionComponent,
    ManageActionDetailsComponent,
    NewUserComponent,
    RainItemizedBillingComponent,
    CustomDatePopupComponent,
    LinkAddressChangeComponent,
    TraceRemovalOperationComponent,
    ManageSuspensionComponent,
    ManageSuspensionPopupComponent,
    ManageAdhocComponent,
    LoginTrendAnalysisComponent,
    ViewAllFnoPackagesComponent,
    TruncPipe,
    ManageAdhocPopupComponent,
    ViewAllFnoPackagesComponent,
    MessagingComponent,
    MessagingAddComponent,
    PortalNotificationsComponent,
    CollectionComponent,
    CollectionPopupComponent,
    ProductAndPriceChangeComponent,
    PaymentHistoryComponent,
    PaymentArrangementComponent,
    ChangeOfBankDetailsComponent,
    AmendBankingDetailsComponent,
    BulkSuspensionReactivationComponent,
    AddBulkSuspensionComponent,
    ManagePushNotificationComponent,
    ManagePushNotificationAddComponent,
    VumatelNetworkEventsComponent,
    ViewVumatelNetworkEventsComponent,
    ManagePromotionAddComponent,
    bannercomponent,
    PromotionSimulationComponent,
    ManagePromotionComponent,
    DrawerComponent,
    NetworkOutageComponent,
    NetworkOutageAddComponent,
    ButtonsComponent,
    RemovePromotionComponent,
    LteManageInventoryComponent,
    LtetopuphistoryComponent,
    ManageOtpNotificationComponent,
    ManageReferralFriendsComponent,
    ManageReferralFriendsComponent,
    RelocationReferralPopupComponent,
    RelocationPromotionComponent,
    ManageRelocationPromotionComponent,
    ManagePaymentArrangementComponent,
    SuspensionScheduleComponent,
    SuspensionProcessHistoryComponent,
    MonthYearPickerComponent,
    AccountTransferExistingComponent,  
    NetworkStatusComponent,
    AccountTransferExistingComponent,
    ManageResellerSalesComponent,
    ManageResellerSalesAddComponent,
    RadactComponent,
  ],
  imports: [
    CommonModule,
    AdditionalFeaturesRoutingModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatSelectFilterModule,
    MatSelectModule,
    FormsModule,
    MatRadioModule,
    MatCheckboxModule,
    MatTabsModule,
    NgMultiSelectDropDownModule.forRoot(),
    MatCarouselModule.forRoot(),
    NgxEditorModule,
    MatSlideToggleModule,
    NgApexchartsModule,
    CarouselModule,
    SharedModule,
    ColorPickerModule,
    MatMenuModule,
    QuillModule.forRoot(),
    MatDividerModule,
    MatCardModule,
    HeaderModule
  ],
  exports: [ButtonsComponent, DrawerComponent],

})

export class AdditionalFeaturesModule { }
